export default __webpack_public_path__ + "static/media/blue-album.70b6c39e.png";